<template>
  <div class="base-checkbox">
    <input
        :id="id"
        ref="checkbox"
        type="checkbox"
        :checked="checked"
        @change="$emit('change', checked)">
    <label
        :for="id"
        @click="click">
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  name: 'BaseCheckbox',
  props: {
    id: {
      type: String,
    },
    modelChecked: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'modelChecked',
    event: 'change',
  },
  data() {
    return {
      checked: this.modelChecked,
    };
  },
  methods: {
    click() {
      this.$refs.checkbox.focus();
      this.checked = !this.checked;
      this.$emit('change', this.checked);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

$size: 1rem;

.base-checkbox {
  padding: 0.25rem;

  input[type=checkbox] {
    // `opacity: 0` rather than `display: none` so that the checkbox can still be focused
    opacity: 0;
    position: absolute;
  }

  input[type=checkbox] + label {
    cursor: pointer;
    display: block;
    min-height: $size;
    padding-left: $size;
    position: relative;

    &:not(:empty) {
      padding-left: 1.75rem;
    }

    &::before {
      background: $dark-gray-300;
      border-radius: 0.125rem;
      content: '';
      height: $size;
      left: 0;
      position: absolute;
      top: calc(50% - #{$size / 2});
      transition: background .2s, box-shadow .2s;
      width: $size;
    }

    &::after {
      font-family: Material Icons Outlined;
      font-size: $size;
      height: $size;
      left: 0;
      line-height: $size;
      position: absolute;
      top: calc(50% - #{$size / 2});
      width: $size;
    }

    &:active {
      &::before {
        background: $primary-900 !important;
      }
    }
  }

  input[type=checkbox]:not(:checked) + label {
    &::after {
      content: '';
    }

    &:hover {
      &::before {
        background: $dark-gray-50;
      }
    }
  }

  input[type=checkbox]:checked + label {
    &::before {
      background: $primary-600;
    }

    &::after {
      // Chrome doesn't support ligatures in contenteditable elements
      // This is the 'check' icon
      content: '\e5ca';
    }

    &:hover {
      &::before {
        background: $primary-400;
      }
    }
  }

  // This is $primary-300 with 0.75 opacity
  $focus-shadow: #f76090bf;

  input[type=checkbox]:focus + label {
    &::before {
      box-shadow: 0 0 0.25rem 0.125rem $focus-shadow;
    }
  }
}
</style>
